module.exports = {
	"ff_all_asset": 40604536222,
	"oil_majors": [
		7667662579,
		0.18883758546281765,
		[
			[
				"Exxon Mobil",
				2993809733
			],
			[
				"Chevron",
				1498603980
			],
			[
				"Shell",
				865765903
			],
			[
				"ConocoPhillips",
				729981540
			],
			[
				"TotalEnergies",
				516448197
			],
			[
				"BP",
				331315401
			],
			[
				"Phillips 66",
				313236173
			],
			[
				"Valero Energy",
				271290692
			],
			[
				"Eni",
				147210960
			]
		]
	],
	"og": [
		16207385006,
		0.3991520779202658,
		[
			[
				"Exxon Mobil",
				2993809733
			],
			[
				"Chevron",
				1498603980
			],
			[
				"Shell",
				865765903
			],
			[
				"Cheniere Energy",
				770339376
			],
			[
				"ConocoPhillips",
				729981540
			],
			[
				"TotalEnergies",
				516448197
			],
			[
				"Williams Companies",
				494166784
			],
			[
				"EOG Resources",
				420654500
			],
			[
				"Kinder Morgan",
				366217797
			],
			[
				"BP",
				331315401
			]
		]
	],
	"ut": [
		11022624928,
		0.271462894385377,
		[
			[
				"NextEra Energy",
				920833723
			],
			[
				"Constellation Energy",
				651811015
			],
			[
				"Southern",
				650325589
			],
			[
				"Duke Energy",
				590984204
			],
			[
				"Vistra",
				423510667
			],
			[
				"American Electric Power",
				357133899
			],
			[
				"Sempra",
				318390660
			],
			[
				"Enel",
				318083211
			],
			[
				"Dominion Energy",
				310556118
			],
			[
				"National Grid",
				294639148
			]
		]
	],
	"other": [
		13374526288,
		0.3293850276943571,
		[
			[
				"Berkshire Hathaway",
				5739597944
			],
			[
				"GE Vernova",
				930579380
			],
			[
				"Siemens",
				802568221
			],
			[
				"Blackstone",
				703248190
			],
			[
				"KKR",
				580238543
			],
			[
				"BHP Group",
				505299318
			],
			[
				"Ares Management",
				446989643
			],
			[
				"CSX",
				394987114
			],
			[
				"Mitsubishi Heavy Indus",
				331265153
			],
			[
				"Siemens Energy",
				323454099
			]
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/TspHoldingStats.json
// module id = 1014
// module chunks = 0